'use strict';

Object.defineProperties(exports, { __esModule: { value: true }, [Symbol.toStringTag]: { value: 'Module' } });

const clsx = require('clsx');
const React = require('react');
const reactAriaComponents = require('react-aria-components');
const Tooltip_FocusableTrigger = require('./FocusableTrigger.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const tooltipBase = "_tooltip-base_1c7gh_1";
const tooltipSingleLine = "_tooltip-single-line_1c7gh_11";
const tooltipMultiLine = "_tooltip-multi-line_1c7gh_17";
const styles = {
	tooltipBase: tooltipBase,
	tooltipSingleLine: tooltipSingleLine,
	tooltipMultiLine: tooltipMultiLine
};

const LINE_HEIGHT = 24;
const PADDING_Y = 2;
const SINGLE_LINE_HEIGHT = LINE_HEIGHT + PADDING_Y * 2;
const TOOLTIP_PLACEMENTS = [
  "bottom",
  "bottom left",
  "bottom right",
  "top",
  "top left",
  "top right",
  "left",
  "left top",
  "left bottom",
  "right",
  "right top",
  "right bottom"
];
const OFFSET_VALUES = {
  small: 4,
  medium: 8,
  large: 12
};
const getOffsetValue = (offset = "medium") => {
  if (typeof offset === "number") {
    return offset;
  }
  return OFFSET_VALUES[offset];
};
const Tooltip = ({ allowMultiline = false, children, content, isOpen, offset = "medium", onOpenChange, placement = "bottom" }) => {
  return React__default.default.createElement(
    reactAriaComponents.TooltipTrigger,
    { closeDelay: 200, delay: 200, isOpen, onOpenChange },
    children,
    React__default.default.createElement(TooltipContent, { allowMultiline, content, offset, placement })
  );
};
const TooltipContent = ({ allowMultiline, content, offset, placement }) => {
  var _a;
  const state = React.useContext(reactAriaComponents.TooltipTriggerStateContext);
  const isOpen = (_a = state === null || state === void 0 ? void 0 : state.isOpen) !== null && _a !== void 0 ? _a : false;
  const [isMultiline, setIsMultiLine] = React.useState(allowMultiline);
  const tooltipRef = React.useRef(null);
  React.useEffect(() => {
    if (tooltipRef.current) {
      const tooltipHeight = tooltipRef.current.getBoundingClientRect().height;
      const isMultiLine = tooltipHeight > SINGLE_LINE_HEIGHT;
      setIsMultiLine(isMultiLine);
    }
  }, [isOpen]);
  return React__default.default.createElement(reactAriaComponents.Tooltip, { className: clsx.clsx(styles.tooltipBase, !allowMultiline && styles.tooltipSingleLine, isMultiline && styles.tooltipMultiLine), "data-zds": true, offset: getOffsetValue(offset), placement, ref: tooltipRef }, content);
};
Tooltip.FocusableTrigger = Tooltip_FocusableTrigger.FocusableTrigger;

exports.TOOLTIP_PLACEMENTS = TOOLTIP_PLACEMENTS;
exports.Tooltip = Tooltip;
exports.default = Tooltip;
//# sourceMappingURL=Tooltip.cjs.js.map
